import styles from '../../DealerLocator.module.scss';
import cx from 'classnames';

interface DealerLocatorSearchResultNameProps {
  children: string;
  isNonInstantAccessDealer?: boolean;
  isStoreLocationListViewUpdateFlag?: boolean;
  isStoreLocationMapViewUpdateFlag?: boolean;
}

export const DealerLocatorSearchResultName = ({
  children,
  isNonInstantAccessDealer = false,
  isStoreLocationListViewUpdateFlag = false,
  isStoreLocationMapViewUpdateFlag = false
}: DealerLocatorSearchResultNameProps) => (
  <p
    className={cx(
      styles['dealer-locator-text'],
      {
        'cat-u-theme-typography-label-lg mb-0 mt-1':
          isStoreLocationListViewUpdateFlag,
        'cat-u-theme-typography-label-sm mb-0':
          !isStoreLocationListViewUpdateFlag
      },
      {
        'u-color--Black': !isNonInstantAccessDealer,
        'u-color--LightGray': isNonInstantAccessDealer,
        'fw-bold': isStoreLocationMapViewUpdateFlag
      }
    )}
  >
    {children}
  </p>
);
